export const PLAID_METADATA = {
  requires_questions: 'User prompted to answer security questions',
  requires_selections: 'User prompted to answer multiple choice question(s)',
  requires_code: 'User prompted to provide a one-time passcode',
  choose_device:
    'User prompted to select a device on which to receive a one-time passcode',
  requires_credentials:
    'User prompted to provide credentials for the selected financial institution or has not yet selected a financial institution',
  requires_account_selection:
    'User prompted to select one or more financial accounts to share',
  requires_oauth: 'User prompted to enter an OAuth flow',
  institution_not_found:
    'User exited the Link flow after unsuccessfully (no results returned) searching for a financial institution',
  'Microdeposits Step Incomplete':
    'User probably exited on second step of manual verification',
};
